<!-- Copyright (c) 2025 Digital Systems (M) Sdn. Bhd. -->

<template>
  <div class="container-rate-main">
    <div>
      <Menus :menu="menu" @menuClicked="menuClicked" />
    </div>
    <div class="table-box-container">
      <TableBox
        title="Container Rate"
        :tableData="containerRateListMaster"
        :maxSelection="1"
        :selectedRow.sync="containerRateTableBoxSelectedRow"
        :loading="containerRateTableBoxLoading"
      />
    </div>

    <PopupEntry
      class="popup-entry-component"
      :show.sync="showPopupEntry"
      v-if="showPopupEntry"
      :title="popupEntryTitle"
      :updatedBy="updatedBy"
      :createdBy="createdBy"
      @save="popupEntrySaveClicked"
      :requiredError="popupEntryRequiredError"
      :successMessages="popupEntrySuccessMessages"
      :messages="popupEntryMessages"
      :errorMessages="popupEntryErrorMessages"
      @requiredClicked="popupEntryRequiredClicked"
      :viewMode="viewMode"
      :cancelButton="viewMode ? 'Close' : 'Cancel'"
    >
    <div style= "display: flex">
          <Input
            class="base-input"
            placeholder="Base"
            :inputValue.sync="baseInputValue"
            :isRequired="true"
            :isDisabled="true"
            :errorMessage.sync="baseErr"
            ref="baseErr"
            validator="text,10,uppercase"
          />

          <CheckBoxV2
          style="margin-left: 10px"
              title="Show Default"
              :isChecked="showDefaultRate"
              :isDisabled="viewMode || editMode"
              @checkBoxClicked="toggleDefault"
            />

    </div>
          <div>
        <div v-if="showDefaultRate">
          <!-- DIV FOR V-IF to show default and show others-->
          <!-- DEFAULT -->
          <DateTimePicker
            :isRequired="true"
            :isDisabled="viewMode"
            placeholder="Effective Date"
            :value.sync="selectedEffectiveDate"
            :errorMessage.sync="effectiveDateErr"
            ref="effectiveDateErr"
            itemKey="combinedEffectiveDate"
          />
        </div>
        <div v-if="showContainerRate">
          <!-- div for v-if to show others and hide default -->

          <InputQuery
            placeholder="Billing Customer"
            :isDisabled="viewMode"
            :items="billingCustomerListMaster"
            :allowFreeText="false"
            :selectedObject.sync="selectedBillingCustomer"
            :errorMessage.sync="billingCustomerErr"
            validator="text,10,uppercase"
            ref="billingCustomerErr"
            itemKey="combinedBillingCustomer"
          />

          <InputQuery
            placeholder="Customer"
            :isDisabled="viewMode"
            :items="customerListMaster"
            :allowFreeText="false"
            :selectedObject.sync="selectedCustomer"
            :errorMessage.sync="customerErr"
            validator="text,10,uppercase"
            ref="customerErr"
            itemKey="combinedCustomer"
          />
          <div style="display: flex">
            <InputQuery
              placeholder="Destination Code"
              :isDisabled="viewMode"
              :isRequired="true"
              :items="filteredDestinationCodesList"
              :allowFreeText="false"
              :selectedObject.sync="selectedDestinationCode"
              :errorMessage.sync="destinationCodeErr"
              validator="text,10,uppercase"
              ref="destinationCodeErr"
              itemKey="combinedDestinationCode"
              @selected="tariffRateSelected"
            />
            <CheckBoxV2
              title="Show All"
              :isChecked.sync="showAllDestinationCodes"
              :isDisabled="viewMode"
            />
          </div>
          <div class="details-row">
            <Dropdown
              placeholder="Haulier"
              :isDisabled="viewMode"
              :isRequired="true"
              :items="haulierListMaster"
              :allowFreeText="false"
              :selectedObject.sync="selectedHaulier"
              :errorMessage.sync="haulierErr"
              validator="text,10,uppercase"
              ref="haulierErr"
              itemKey="combinedHaulier"
            />

            <Dropdown
              placeholder="Handling Type"
              :isDisabled="viewMode"
              :isRequired="true"
              :items="handlingTypeListMaster"
              :allowFreeText="false"
              :selectedObject.sync="selectedHandlingType"
              :errorMessage.sync="handlingTypeErr"
              validator="text,5,uppercase"
              ref="handlingTypeErr"
              itemKey="combinedHandlingType"
            />
          </div>
          <div class="details-row">
            <Dropdown
              placeholder="Container Type"
              :isDisabled="viewMode"
              :isRequired="true"
              :items="containerTypeListMaster"
              :allowFreeText="false"
              :selectedObject.sync="selectedContainerType"
              :errorMessage.sync="containerTypeErr"
              validator="text,5,uppercase"
              ref="containerTypeErr"
              itemKey="combinedContainerType"
            />
            <Dropdown
              placeholder="Delivery Type"
              :isDisabled="viewMode"
              :isRequired="true"
              :items="deliveryTypeListMaster"
              :allowFreeText="false"
              :selectedObject.sync="selectedDeliveryType"
              :errorMessage.sync="deliveryTypeErr"
              validator="text,5,uppercase"
              ref="deliveryTypeErr"
              itemKey="combinedDeliveryType"
            />
          </div>
        </div>
        <BoxContainer title="Tariff Rate">
        <!-- Tariff row -->
        <div class="tariff-rate-input">
          <Input
            placeholder="Area Code"
            :isDisabled="true"
            :inputValue.sync="tariffRateInput"
            validator="positiveDecimal,14,2"
          />
          <Input placeholder="20' " :isDisabled="true" :inputValue.sync="tr20Amt" validator="positiveDecimal,14,2" />

          <Input placeholder="40' " :isDisabled="true" :inputValue.sync="tr40Amt" validator="positiveDecimal,14,2" />

          <Input placeholder="Toll " :isDisabled="true" :inputValue.sync="trTollAmt" validator="positiveDecimal,14,2" />
        </div>
        </BoxContainer>
        <BoxContainer title="Rebate">
      <!-- Rebate Row -->
        <div class="rebate-input">

          <Dropdown
            style="width: 34%"
            placeholder="Amount Type"
            :isDisabled="viewMode"
            :items="symbolListMaster"
            :allowFreeText="false"
            :selectedObject.sync="selectedSymbol"
            :errorMessage.sync="symbolErr"
            validator="text,1"
            ref="symbolErr"
            itemKey="label"
          />

          <Input
            placeholder="20' "
            :isDisabled="viewMode"
            :inputValue.sync="rb20Amt"
            validator="positiveDecimal,14,2"
          />
          =
          <Input placeholder="20' " :isDisabled="true" :inputValue.sync="rb20Amt" validator="positiveDecimal,14,2" />
          <Dropdown
            style="width: 34%"
            placeholder="Rebate Type"
            :isDisabled="viewMode"
            :items="symbolListMaster"
            :allowFreeText="false"
            :selectedObject.sync="selectedSymbol"
            :errorMessage.sync="symbolErr"
            validator=""
            ref="symbolErr"
            itemKey="label"
          />

          <Input
            placeholder="40' "
            :isDisabled="viewMode"
            :inputValue.sync="rb40Amt"
            validator="positiveDecimal,14,2"
          />
          =
          <Input placeholder="40' " :isDisabled="true" :inputValue.sync="rb40Amt" validator="positiveDecimal,14,2" />
        </div>  
        </BoxContainer>
        <!-- charge code list -->
        <div class="charge-code-component">
          <BoxContainer title="Charge Codes">
            <div class="charge-code-table">
              <div class="charge-code-header">
                <div class="no-column"> No. </div>
                <div class="charge-code-column">Charge Code</div>
                <div class="amount-column"> Amount </div>
                <div class="adjust-amount-column"> Adjust Amount </div>
                <div class="nett-column"> Nett </div>
                <div class="default-column"></div>
                <div calss="actions-column"></div>
              </div>
              <!-- rows -->
              <div v-for="(chargeCode, index) in chargeCodes" :key="index" class="charge-code-row">
                <div class="no-column" style="font-size: 14px; margin-top: 8px">{{ index + 1 }}</div>
                <!-- charge code input -->
                <div class="charge-code-column">
                  <InputQuery
                    placeholder="ChargeCode"
                    class="charge-code-name-input"
                    :items="chargeCodeListMaster"
                    :selectedObject.sync="chargeCode['Charge Code']"
                    :isDisabled="viewMode || (chargeCode['Default Charges'] === '1' && viewModeDefault)"
                    :errorMessage.sync="chargeCodeNameErr"
                    ref="chargeCodeNameErr"
                    validator="text,10,uppercase"
                    itemKey="combinedChargeCode"
                  />
                </div>
                <!-- amount -->
                <div class="amount-input">
                  <Dropdown
                    style="width: 50%"
                    placeholder="Type"
                    :isDisabled="viewMode || (chargeCode['Default Charges'] === '1' && viewModeDefault)"
                    :items="symbolListMaster"
                    :allowFreeText="false"
                    :selectedObject.sync="chargeCode['Amount Type']"
                    :errorMessage.sync="symbolErr"
                    validator="text,1"
                    ref="symbolErr"
                    itemKey="label"
                  />
                  <Input
                    style="width: 50%"
                    placeholder="20' "
                    :isDisabled="viewMode || (chargeCode['Default Charges'] === '1' && viewModeDefault)"
                    :inputValue.sync="chargeCode['20Amount']"
                    validator="positiveDecimal,14,2"
                  />

                  <Input
                    style="width: 50%"
                    placeholder="40' "
                    :isDisabled="viewMode || (chargeCode['Default Charges'] === '1' && viewModeDefault)"
                    :inputValue.sync="chargeCode['40Amount']"
                    validator="positiveDecimal,14,2"
                  />
                </div>
                <div class="adjust-amount-input">
                  <!-- adjust amount -->
                  <Dropdown
                    style="width: 50%"
                    placeholder="Type"
                    :isDisabled="viewMode || (chargeCode['Default Charges'] === '1' && viewModeDefault)"
                    :items="symbolListMaster"
                    :allowFreeText="false"
                    :selectedObject.sync="chargeCode['Rebate Type']"
                    :errorMessage.sync="symbolErr"
                    validator="text,1"
                    ref="symbolErr"
                    itemKey="label"
                  />
                  <Input
                    style="width: 50%"
                    placeholder="20' "
                    :isDisabled="viewMode || (chargeCode['Default Charges'] === '1' && viewModeDefault)"
                    :inputValue.sync="chargeCode['20Rebate']"
                    validator="positiveDecimal,14,2"
                  />

                  <Input
                    style="width: 50%"
                    placeholder="40' "
                    :isDisabled="viewMode || (chargeCode['Default Charges'] === '1' && viewModeDefault)"
                    :inputValue.sync="chargeCode['40Rebate']"
                    validator="positiveDecimal,14,2"
                  />
                </div>

                <div class="nett-input">
                  <!-- nett -->
                  <Input
                    style="width: 60%"
                    placeholder="20' "
                    :isDisabled="true"
                    :inputValue="calculateNett20(chargeCode)"
                    validator="positiveDecimal,14,2"
                  />

                  <Input
                    style="width: 60%"
                    placeholder="40' "
                    :isDisabled="true"
                    :inputValue="calculateNett40(chargeCode)"
                    validator="positiveDecimal,14,2 "
                  />
                </div>
                <!-- default checkbox -->
                <div class="default-column">
                  <CheckBoxV2
                    class="default-rate-check-box"
                    title="Default"
                    :isChecked="chargeCode['Default Charges'] === '1'"
                    @checkBoxClicked="handleDefaultChargesChange(chargeCode, $event)"
                    :isDisabled="viewMode || showDefaultRate"
                    :errorMessage.sync="defaultRateErr"
                    ref="defaultRateErr"
                  />
                </div>
                <!-- delete button for each charge code-->
                <div class="actions-column" style="height: 100%; padding-bottom: 10px">
                  <button @click="deleteChargeCodeButtonClicked(index)" :disabled="viewMode">Delete</button>
                </div>
              </div>
              <div>
                <!-- add button for charge code -->
                <button @click="addChargeCodeButtonClicked" :disabled="viewMode" style="margin: 10px; margin-left: 4px"
                  >Add</button
                >
              </div>
            </div>
          </BoxContainer>
        </div>
        <!-- Total nett output -->
        <BoxContainer>
          <div style="display: flex; flex-direction: row; justify-content: flex-end">
            <div style="display: flex; margin-right: 20px">
              <div style="align-content: center; margin-right: 10px; font-size: 1.1em"> Total Nett 20' : </div>
              <div style="display: flex">
                <div
                  class="total-block"
                  style="
                    background-color: #467cdc;
                    color: white;
                    font-size: 1.1em;
                    font-weight: bold;
                    text-align: right;
                    display: inline;
                    padding-right: 5px;
                  "
                  >MYR {{ calculateTotalNett20() ? calculateTotalNett20() : 0 }}</div
                >
              </div>
            </div>
            <div style="display: flex">
              <div style="align-content: center; margin-right: 10px; font-size: 1.1em">Total Nett 40' :</div>
              <div style="display: flex">
                <div
                  class="total-block"
                  style="
                    background-color: #467cdc;
                    color: white;
                    font-size: 1.1em;
                    font-weight: bold;
                    text-align: right;
                    display: inline;
                    padding-right: 5px;
                  "
                  >MYR {{ calculateTotalNett40() ? calculateTotalNett40() : 0 }}</div
                >
              </div>
            </div>
          </div>
        </BoxContainer>
      </div>

    </PopupEntry>
  </div>
</template>

<script>
export default {
  components: {},
  computed: {},

  data: function () {
    return {
      defaultRate: '',
      showContainerRate: false,
      showDefaultRate: false,
      // edit mode is to disabled the checkbox while editing for Show Default
      editMode: false,

      menu: [
        {
          title: 'New Rate',
          icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-add-new-50.png',
          key: 'MnuNew',
          visible: true,
          enabled: false,
        },
        {
          title: 'Edit Rate',
          icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-edit-64%20(1).png',
          key: 'MnuEdit',
          visible: true,
          enabled: false,
        },
                {
          title: 'Delete Rate',
          icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-reduce-50.png',
          key: 'MnuDelete',
          visible: false,
          enabled: false,
        },
        {
          title: 'View Rate',
          icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-view-64.png',
          key: 'MnuQuery',
          visible: true,
          enabled: false,
        },

      ],
      // all list master for dropdown or
      containerRateListMaster: [],
      containerRateTableBoxSelectedRow: [],
      containerRateTableBoxLoading: false,
      chargeCodeListMaster: [],
      billingCustomerListMaster: [],
      customerListMaster: [],
      destinationCodeListMaster: [],
      haulierListMaster: [],
      containerTypeListMaster: [],
      handlingTypeListMaster: [],
      deliveryTypeListMaster: [],
      symbolListMaster: [
        { '#': 1, label: '%' },
        { '#': 2, label: '$' },
      ],

      //popup entry state
      showPopupEntry: false,
      popupEntryTitle: '',
      updatedBy: '',
      createdBy: '',
      viewMode: false,
      viewModeDefault: true,
      popupEntryRequiredError: [],
      popupEntrySuccessMessages: [],
      popupEntryMessages: [],
      popupEntryErrorMessages: [],

      //popup entry common field
      baseName: '',
      baseInputValue: '',
      baseErr: '',
      selectedBillingCustomer: null,
      billingCustomerErr: '',
      selectedCustomer: null,
      customerErr: '',
      selectedDestinationCode: null,
      destinationCodeErr: '',
      selectedHaulier: null,
      haulierErr: '',
      selectedContainerType: null,
      containerTypeErr: '',
      selectedHandlingType: null,
      handlingTypeErr: '',
      selectedDeliveryType: null,
      deliveryTypeErr: '',
      tariffRateInput: '',
      defaultRateErr: '',
      symbolErr: '',
      tr20Amt: '0.00',
      tr40Amt: '0.00',
      trTollAmt: '0.00',
      rb20Amt: '0.00',
      rb40Amt: '0.00',
      chargeCodeNameErr: '',
      n20Amt: '0.00',
      n40Amt: '0.00',
      selectedEffectiveDate: null,
      effectiveDateErr: '',
      // for chargecodelist
      chargeCodes: [],
      // this is the checkbox to display all the destination codes
      showAllDestinationCodes: false, 
      // for filter the destination code, because every customer have specific destination codes, if want to see other destination codes can check the show all box
      filteredDestinationCodesList: [],
    };
  },
  props: {},
  methods: {

    //when press the checkbox it will show default ,otherwise is container rate
    toggleDefault(isChecked) {
      if (!isChecked) {
      this.showDefaultRate = false;
      this.showContainerRate = true;
      this.viewModeDefault = true;
      } else {
        this.showDefaultRate = true;
        this.showContainerRate = false;
        this.viewModeDefault = false;
      }
    },
    // this function is to filter and sort the latest effective date (only default rate got effective date)
    getDefaultChargeCodes: async function () {
      const result = await this.$apiCallV2('/Master/GetListMaster', {
        masterfile: 'HAULIERCHARGES',
        effectivedate: this.selectedEffectiveDate ? this.selectedEffectiveDate['Effective Date'] : null,
      });
      //today's date
      const today = new Date();
      const latestEffectiveDate = result.reduce((latest,item) =>  {
        const effectiveDate = new Date(item['Effective Date']);
        // ensure 'Default Rate' is 'Yes' and the effective date is not in the future
        if (item['Default Rate'] === 'Yes' && effectiveDate <= today){
          // if no latest yet or got one is more recent, update the latest
        // checks if the effectiveDate of the item is more greater than the previously stored latest effective date.
        // if !latest is true or the current item is more recent effective date, return item.
          return !latest || effectiveDate > new Date(latest['Effective Date']) ? item : latest;
        }
        return latest;
      }, null);

      return latestEffectiveDate;
    },
    //filter the destination code list based on the selected customer
    updateFilteredDestinationCodes: function () {
      if (this.showAllDestinationCodes) {
        this.filteredDestinationCodesList = this.destinationCodeListMaster;
      } else if (this.selectedCustomer) {
        this.filteredDestinationCodesList = this.destinationCodeListMaster.filter(
          (code) => code['Customer Number'] === this.selectedCustomer['Customer Code'],
        );
      } else {
        this.filteredDestinationCodesList = [];
      }
    },
    // get the base value, and display in the input(ex. PKG)
    fetchCurrentBase: async function () {
      const result = await this.$apiCallV2('/Login/GetDetails');
      this.baseName = result['BaseName'];
    },
    // selected a destination code it have these value, it will display simultaneously
    tariffRateSelected: function (newSelectedDestinationCode) {
      this.tariffRateInput = newSelectedDestinationCode['CHAM Area Code'] || '';
      this.tr20Amt = newSelectedDestinationCode['20Rate'] || '';
      this.tr40Amt = newSelectedDestinationCode['40Rate'] || '';
      this.trTollAmt = newSelectedDestinationCode['Toll Rate'] || '';
    },
    // calculation for nett20
    calculateNett20: function (chargeCode) {
      const amount = Number(chargeCode['20Amount']);
      const rebate = Number(chargeCode['20Rebate']);
      return (amount + rebate).toFixed(2);
    },
    // calculation for nett40
    calculateNett40: function (chargeCode) {
      const amount = Number(chargeCode['40Amount']);
      const rebate = Number(chargeCode['40Rebate']);
      return (amount + rebate).toFixed(2);
    },
    // calculation for totalnett 20
    calculateTotalNett20: function () {
      //to store the sum of all values
      let total = 0;
      //go through each item (chargecode) in the chargeCodes array one by one
      this.chargeCodes.forEach((chargeCode) => {
        //return a number and add it to the total
        total += Number(this.calculateNett20(chargeCode)); // Force numeric addition
      });
      return total; // Ensure final result is a number
    },
    // calculation for totalnett40
    calculateTotalNett40: function () {
      let total = 0;
      this.chargeCodes.forEach((chargeCode) => {
        total += Number(this.calculateNett40(chargeCode)); // Force numeric addition
      });
      return total;
    },
    // button for add more chargecode in chargecodelist
    addChargeCodeButtonClicked: function (_pointerEvent) {
      this.chargeCodes.push({
        Base: '',
        'Default Charges': '0',
        'Charge Code': null,
        'Amount Type': null,
        '20Amount': '0.00',
        '40Amount': '0.00',
        'Rebate Type': null,
        '20Rebate': '0.00',
        '40Rebate': '0.00',
      });
    },
    // button to delete charge code
    deleteChargeCodeButtonClicked: async function (index) {
      const deleteConfirmation = await this.$showAlert(
        'warning',
        'Delete Charge Code',
        'Are you sure you wish to delete this charge code?',
        [{ text: 'Delete', color: 'Red', textColor: 'white' }, { text: 'Cancel' }],
      );
      if (deleteConfirmation === 'Delete') {
        this.chargeCodes.splice(index, 1);
      }
    },

    //retrieve data to display in table
    getContainerRateListMaster: async function () {
      this.containerRateTableBoxLoading = true;
      this.containerRateListMaster = [];
      this.containerRateTableBoxSelectedRow = [];
      this.containerRateListMaster = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'HAULIERCHARGES' });
      this.containerRateTableBoxLoading = false;
    },
    
    getContainerRateDetails: async function (containerRate) {
      const results = await this.$apiCallV2('/Master/GetDetailsMaster', {
        masterfile: 'HAULIERCHARGES',
        recordid: 'HAULIERCHARGES',
        customer: containerRate['Customer'] ?? containerRate['customer'] ?? '',
        destinationcode: containerRate['Destination Code'] ?? containerRate['destinationcode'] ?? '',
        haulier: containerRate['Haulier'] ?? containerRate['haulier'] ?? '',
        containertype: containerRate['Container Type'] ?? containerRate['containertype'] ?? '',
        base: containerRate['Base'] ?? containerRate['base'] ?? '',
        handlingtype: containerRate['Handling Type'] ?? containerRate['handlingtype'] ?? '',
        deliverytype: containerRate['Delivery Type'] ?? containerRate['deliverytype'] ?? '',
        billingcustomer: containerRate['Billing Customer'] ?? containerRate['billingcustomer'] ?? '',
        datestart: containerRate['Effective Date'] ?? containerRate['datestart'] ?? '',
        defaultrate: containerRate['Default Rate'] ?? containerRate['defaultrate'] ?? '',
      });
      return results;
    },

    menuClicked: async function (e) {
      this.clearPopupEntryMessages();
      this.resetPopupEntryFields();

      switch (e.title) {
        case 'New Rate': {
          
          this.popupEntryTitle = 'New Rate';
          this.viewMode = false;
          this.editMode = false;
          this.showPopupEntry = true;
          // this.showDefault = true;
          this.showContainerRate = true;
          
          // whenever press new, the chargecode list will display that default charge code based on default rate
          const latestEffectiveDate = await this.getDefaultChargeCodes();
          if (latestEffectiveDate) {
            // get the latest effective date, fetch from container rate details based on the date
            const containerRateDetails = await this.getContainerRateDetails(latestEffectiveDate);
          // retrieves the list of charge codes from ['HaulierCharges']['ChargeCodeList'] and stores inside this.chargeCodes
            this.chargeCodes = containerRateDetails['HaulierCharges']['ChargeCodeList'];
            // for each charge code in the list, populate all the value using listmaster
            this.chargeCodes.forEach((chargeCode) => {
            chargeCode['Charge Code'] = this.populateObject(
                this.chargeCodeListMaster,
                'Charge Code',
                chargeCode['Charge Code'],
              );
              chargeCode['Amount Type'] = this.populateObject(
                this.symbolListMaster,
                'label',
                chargeCode['Amount Type'],
              );
              chargeCode['Rebate Type'] = this.populateObject(
                this.symbolListMaster,
                'label',
                chargeCode['Rebate Type'],
              );
              

              // store default values, save original values based on the lastest effective date
              chargeCode._defaultValues = {
                '20Amount': chargeCode['20Amount'],
                '40Amount': chargeCode['40Amount'],
                '20Rebate': chargeCode['20Rebate'],
                '40Rebate': chargeCode['40Rebate'],
                'Amount Type': chargeCode['Amount Type'],
                'Rebate Type': chargeCode['Rebate Type'],
              };

            });
          }
          
          break;
        }
        case 'Edit Rate': {
          if (this.containerRateTableBoxSelectedRow.length == 0) {
            this.$showAlert('error', 'No Container Rate is selected', 'Please select a Container Rate to edit');
            break;
          }
          this.editMode = true;
          if (this.containerRateTableBoxSelectedRow[0]['Default Rate'] === 'Yes') {
            this.showDefaultRate = true;
            this.showContainerRate = false;
            this.viewModeDefault = false;
          } else {
            this.showDefaultRate = false;
            this.showContainerRate = true;
            this.viewModeDefault = true;

          }

          this.$fullscreenLoading('Getting Container Rate Details');
          this.populatePopupEntryFields(await this.getContainerRateDetails(this.containerRateTableBoxSelectedRow[0]));
          this.$fullscreenLoading();

          //checked will show original value
          this.chargeCodes.forEach((chargeCode) => {
            chargeCode._defaultValues = {
              '20Amount': chargeCode['20Amount'],
              '40Amount': chargeCode['40Amount'],
              '20Rebate': chargeCode['20Rebate'],
              '40Rebate': chargeCode['40Rebate'],
              'Amount Type': chargeCode['Amount Type'],
              'Rebate Type': chargeCode['Rebate Type'],
            };
          });

          this.viewMode = false;
          this.showPopupEntry = true;
          this.popupEntryTitle = 'Edit Rate';

          const latestEffectiveDate = await this.getDefaultChargeCodes();
            // this is for edit the container rate's charge code list, when user want to change back the charge code to default rate, can check the checkbox, it will return back the latest effective date charge code default rate
          if (latestEffectiveDate) {
            const containerRateDetails = await this.getContainerRateDetails(latestEffectiveDate);
            const defaultChargeCodes = containerRateDetails['HaulierCharges']['ChargeCodeList'];
            defaultChargeCodes.forEach((defaultChargeCode) => {
              const chargeCode = this.chargeCodes.find(
                (cc) => cc['Charge Code']['Charge Code'] === defaultChargeCode['Charge Code'],
              );
              if (chargeCode) {
                chargeCode._defaultValues = {
                  '20Amount': defaultChargeCode['20Amount'],
                  '40Amount': defaultChargeCode['40Amount'],
                  '20Rebate': defaultChargeCode['20Rebate'],
                  '40Rebate': defaultChargeCode['40Rebate'],
                  'Amount Type': this.populateObject(this.symbolListMaster, 'label', defaultChargeCode['Amount Type']),
                  'Rebate Type': this.populateObject(this.symbolListMaster, 'label', defaultChargeCode['Rebate Type']),
                };
              }
            });
          }
          break;
        }
        case 'Delete Rate': {
          if (this.containerRateTableBoxSelectedRow.length == 0) {
            this.$showAlert('error', 'No Container Rate is selected', 'Please select a Container Rate to delete');
            break;
          }

          this.$fullscreenLoading('Getting Container Rate Details');
          this.populatePopupEntryFields(await this.getContainerRateDetails(this.containerRateTableBoxSelectedRow[0]));
          this.$fullscreenLoading();

          if (this.containerRateTableBoxSelectedRow[0]['Default Rate'] === 'Yes') {
            this.showDefaultRate = true;
            this.showContainerRate = false;
            this.viewModeDefault = false;
          } else {
            this.showDefaultRate = false;
            this.showContainerRate = true;
            this.viewModeDefault = true;

          }

          const promptMessage = `Are you sure you want to delete Container Rate <b>${this.containerRateTableBoxSelectedRow[0]}</b>?`;
          const deleteConfirmation = await this.$showAlert('warning', 'Delete Container Rate', promptMessage, [
            { text: 'Delete', textColor: 'white', color: 'red' },
            { text: 'Cancel' },
          ]);

          if (deleteConfirmation == 'Cancel') {
            break;
          }
          this.$fullscreenLoading('Deleting Container Rate');
          const result = await this.$apiCallV2(
            '/ContainerRate/SaveHaulierCharges',
            this.formatSaveContainerRateRequestBody('D'),
          );
          this.$fullscreenLoading();
          if (result[0]['Results'] != '0') {
            this.$showAlert(
              'error',
              'Container Rate NOT DELETED',
              `There was an error deleting Container Rate ${this.containerRateTableBoxSelectedRow[0]}`,
            );
            break;
          }

          this.$showAlert(
            'success',
            'Container Rate Deleted',
            `Successfully deleted Container Rate ${this.containerRateTableBoxSelectedRow[0]}`,
          );
          this.containerRateTableBoxSelectedRow = [];
          this.getContainerRateListMaster();
          break;
        }
        case 'View Rate':
          if (this.containerRateTableBoxSelectedRow == 0) {
            this.$showAlert('error', 'No Container Rate is selected', 'Please select a Container Rate to view');
            break;
          }
          if (this.containerRateTableBoxSelectedRow[0]['Default Rate'] === 'Yes') {
            this.showDefaultRate = true;
            this.showContainerRate = false;
            this.viewModeDefault = false;
          } else {
            this.showDefaultRate = false;
            this.showContainerRate = true;
            this.viewModeDefault = true;

          }

          this.$fullscreenLoading('Getting Container Rate Details');
          this.populatePopupEntryFields(await this.getContainerRateDetails(this.containerRateTableBoxSelectedRow[0]));


          this.$fullscreenLoading();
          this.popupEntryTitle = 'View Rate';
          this.viewMode = true;
          this.showPopupEntry = true;
          break;
    }
    },
    clearPopupEntryMessages: function () {
      this.popupEntryRequiredError = [];
      this.popupEntrySuccessMessages = [];
      this.popupEntryMessages = [];
      this.popupEntryErrorMessages = [];
    },
    resetPopupEntryFields: function () {
      this.createdBy = '';
      this.updatedBy = '';
      this.popupEntryTitle = '';
      this.viewModeDefault = true;
      this.showDefaultRate= false;
      this.baseInputValue = this.baseName;
      this.baseErr = '';
      this.selectedBillingCustomer = null;
      this.billingCustomerErr = '';
      this.selectedCustomer = null;
      this.customerErr = '';
      this.selectedDestinationCode = null;
      this.destinationCodeErr = '';
      this.selectedHaulier = null;
      this.haulierErr = '';
      this.selectedContainerType = null;
      this.containerTypeErr = '';
      this.selectedHandlingType = null;
      this.handlingTypeErr = '';
      this.selectedDeliveryType = null;
      this.deliveryTypeErr = '';
      this.tariffRateInput = '';
      this.tr20Amt = '0.00';
      this.tr40Amt = '0.00';
      this.trTollAmt = '0.00';
      this.rb20Amt = '0.00';
      this.rb40Amt = '0.00';
      this.selectedSymbol = null;
      this.symbolErr = '';
      this.chargeCodeNameErr = '';
      this.defaultRateErr = '';
      this.n20Amt = '0.00';
      this.n40Amt = '0.00';
      this.selectedEffectiveDate = null;
      this.effectiveDateErr = '';
      this.chargeCodes = [
        {
          Base: '',
          'Default Charges': '0',
          'Charge Code': null,
          'Amount Type': null,
          '20Amount': '0.00',
          '40Amount': '0.00',
          'Rebate Type': null,
          '20Rebate': '0.00',
          '40Rebate': '0.00',
        },
      ];
    },

    populatePopupEntryFields: async function (tableDetails) {
      const containerRateDetails = tableDetails['HaulierCharges'];
      // this.createdBy = `${containerRateDetails['Created By']?.trim() ?? ''} ${containerRateDetails['Created On'] ? new Date(containerRateDetails['CreatedDate']).formatString('dd/MM/yyyy HH:mm') : ''}`;
      this.defaultRate = containerRateDetails['Default Rate'];
      this.updatedBy = `${containerRateDetails['UserID']?.trim() ?? ''} ${containerRateDetails['Date Updated'] ? new Date(containerRateDetails['Date Updated']).formatString('dd/MM/yyyy HH:mm') : ''}`;
      this.selectedEffectiveDate =
        containerRateDetails['Date Start'] ? new Date(containerRateDetails['Date Start']) : null;
      this.baseInputValue = this.populateTextTrim(containerRateDetails['Base']);
      this.selectedBillingCustomer =
        containerRateDetails['Billing Customer'] ?
          this.populateObject(this.billingCustomerListMaster, 'Customer Code', containerRateDetails['Billing Customer'])
        : null;
      this.selectedCustomer =
        containerRateDetails['Customer'] ?
          this.populateObject(this.customerListMaster, 'Customer Code', containerRateDetails['Customer'])
        : null;

      this.selectedDestinationCode =
        containerRateDetails['Destination Code'] ?
          this.populateObject(
            this.destinationCodeListMaster,
            'Destination Code',
            containerRateDetails['Destination Code'],
          )
        : null;
      // called the function to populate the tariff rate
      const tariffRate = containerRateDetails['TariffRate'] || {};
      this.tariffRateInput = this.populateTextTrim(tariffRate['Destination Code']) || '';
      this.tr20Amt = this.populateTextTrim(tariffRate['20Rate']) || '';
      this.tr40Amt = this.populateTextTrim(tariffRate['40Rate']) || '';
      this.trTollAmt = this.populateTextTrim(tariffRate['Toll']) || '';
      this.selectedHaulier =
        containerRateDetails['Haulier'] ?
          this.populateObject(this.haulierListMaster, 'Haulier Code', containerRateDetails['Haulier'])
        : null;

      this.selectedContainerType =
        containerRateDetails['Container Type'] ?
          this.populateObject(this.containerTypeListMaster, 'Cont Type', containerRateDetails['Container Type'])
        : null;

      this.selectedHandlingType =
        containerRateDetails['Handling Type'] ?
          this.populateObject(this.handlingTypeListMaster, 'Handling Type', containerRateDetails['Handling Type'])
        : null;

      this.selectedDeliveryType =
        containerRateDetails['Delivery Type'] ?
          this.populateObject(this.deliveryTypeListMaster, 'Delivery Type', containerRateDetails['Delivery Type'])
        : null;

      this.rb20Amt = this.populateTextTrim(containerRateDetails['20VendorRebate']);
      this.rb40Amt = this.populateTextTrim(containerRateDetails['40VendorRebate']);
      this.n20Amt = this.populateTextTrim(containerRateDetails['20Amount']);
      this.n40Amt = this.populateTextTrim(containerRateDetails['40Amount']);
      //for charge code list detail data
      this.chargeCodes = containerRateDetails['ChargeCodeList'];
      this.chargeCodes.forEach((chargeCode) => {
        chargeCode['Amount Type'] = this.populateObject(this.symbolListMaster, 'label', chargeCode['Amount Type']);
        chargeCode['Rebate Type'] = this.populateObject(this.symbolListMaster, 'label', chargeCode['Rebate Type']);
        chargeCode['Charge Code'] = this.populateObject(
          this.chargeCodeListMaster,
          'Charge Code',
          chargeCode['Charge Code'],
        );
        chargeCode.default40Amount = chargeCode['40Amount'];
        chargeCode.default20Rebate = chargeCode['20Rebate'];
        chargeCode.default40Rebate = chargeCode['40Rebate'];

        chargeCode['Default Charges'] = chargeCode['Default Charges'] === '1' ? '1' : '0';
      });
    },

    checkPopupEntryFields: function () {
      let error = false;

      this.clearPopupEntryMessages();
      if (this.showDefaultRate) {
        if (!this.selectedEffectiveDate) {
          this.effectiveDateErr = 'Effective Date is required!';
          this.popupEntryRequiredError.push({ key: 'effectiveDateErr', value: 'Effective Date is required!' });
          error = true;
        }
      } else if (this.showContainerRate) {
        if (this.baseInputValue.trim() === '') {
          this.baseErr = 'Base is required!';
          this.popupEntryRequiredError.push({ key: 'baseErr', value: 'Base is required!' });
          error = true;
        } else if (this.baseInputValue.length > 10) {
          this.baseErr = 'Base cannot exceed 10 characters!';
          this.popupEntryRequiredError.push({ key: 'baseErr', value: 'Base cannot exceed 10 characters' });
          error = true;
        }

        if (!this.selectedDestinationCode) {
          this.destinationCodeErr = 'Destination Code is required!';
          this.popupEntryRequiredError.push({ key: 'destinationCodeErr', value: 'Destination Code is required!' });
          error = true;
        }

        if (!this.selectedHaulier) {
          this.haulierErr = 'Haulier is required!';
          this.popupEntryRequiredError.push({ key: 'haulierErr', value: 'Haulier is required!' });
          error = true;
        }

        if (!this.selectedContainerType) {
          this.containerTypeErr = 'Container Type is required!';
          this.popupEntryRequiredError.push({ key: 'containerTypeErr', value: 'Container Type is required!' });
          error = true;
        }

        if (!this.selectedHandlingType) {
          this.handlingTypeErr = 'Handling Type is required!';
          this.popupEntryRequiredError.push({ key: 'handlingTypeErr', value: 'Handling Type is required!' });
          error = true;
        }

        if (!this.selectedDeliveryType) {
          this.deliveryTypeErr = 'Delivery Type is required!';
          this.popupEntryRequiredError.push({ key: 'deliveryTypeErr', value: 'Delivery Type is required!' });
          error = true;
        }

        if (this.defaultRate !== 'Yes') {
          const allChecked = this.chargeCodes.every((chargeCode) => chargeCode['Default Charges'] === '1');
          if (allChecked) {
            this.defaultRateErr = 'At least one charge code must be unchecked!';
            this.popupEntryRequiredError.push({
              key: 'defaultRateErr',
              value: 'At least one charge code must be unchecked!',
            });
            error = true;
          }
        }

        //check if there is at least one charge code
        if (this.chargeCodes.length === 0) {
          this.chargeCodeNameErr = 'At least one charge code is required!';
          this.popupEntryRequiredError.push({
            key: 'chargeCodeNameErr',
            value: 'At least one charge code is required!',
          });
        }

        return error;
      }
    },

    popupEntrySaveClicked: async function () {
      const isInvalid = this.checkPopupEntryFields();
      if (isInvalid) {
        return;
      }

      const action = this.popupEntryTitle[0];
      let requestBody = this.formatSaveContainerRateRequestBody(action);
      this.$fullscreenLoading('Saving Container Rate');
      let result = await this.$apiCallV2('/ContainerRate/SaveHaulierCharges', requestBody);
      this.$fullscreenLoading();
      if (result[0]['Results'] != '0') {
        // Check if the error message indicates existing data
        if (result[0]['ErrMsg'] === 'There are existing data, do you want to overwrite them?') {
          const promptMessage = `There are existing data, do you want to overwrite them?`;
          const overwriteConfirmation = await this.$showAlert('warning', 'Overwrite Container Rate', promptMessage, [
            { text: 'Overwrite', textColor: 'white', color: 'red' },
            { text: 'Cancel' },
          ]);

          if (overwriteConfirmation == 'Cancel') {
            return;
          }

          // proceed with overwrite
          this.$fullscreenLoading('Overwriting Container Rate');
          requestBody = { ...requestBody, action: 'N', confirmsave: '1' };
          result = await this.$apiCallV2('/ContainerRate/SaveHaulierCharges', requestBody);
          this.$fullscreenLoading();

          if (result[0]['Results'] != '0') {
            this.popupEntryErrorMessages.push(`There was an error overwriting Container Rate: ${result[0]['ErrMsg']}`);
            return;
          }
        } else {
          // Handle other errors
          if (action == 'N') {
            this.popupEntryErrorMessages.push(`There was an error creating Container Rate: ${result[0]['ErrMsg']}`);
          } else {
            this.popupEntryErrorMessages.push(`There was an error editing Container Rate: ${result[0]['ErrMsg']}`);
          }
          return;
        }
      }
      //save successful
      this.viewMode = true;
      this.popupEntryTitle = 'View Rate';
      this.resetPopupEntryFields();

      this.$fullscreenLoading('Refreshing Container Rate');
      await this.getContainerRateListMaster();

      this.$fullscreenLoading('Getting Container Rate Details');
      let containerRateDetails = [];
      containerRateDetails = await this.getContainerRateDetails(requestBody);
      this.populatePopupEntryFields(containerRateDetails);
      if (action == 'N') {
        this.popupEntrySuccessMessages.push(`Successfully created Container Rate: ${this.baseInputValue}`);
      } else {
        this.popupEntrySuccessMessages.push(`Successfully edited Container Rate: ${this.baseInputValue}`);
      }

      this.$fullscreenLoading();
    },

    formatSaveContainerRateRequestBody: function (action) {
      let requestBody;
      // for default rate
      if (this.showDefaultRate) {
        requestBody = {
          action: action,
          dateupdate: new Date().formatString('yyyy-MM-dd'),
          base: this.baseInputValue.trim(),
          datestart: this.selectedEffectiveDate.formatString('yyyy-MM-dd'),
          billingcustomer: '',
          customer: '',
          destinationcode: '',
          haulier: '',
          containertype: '',
          handlingtype: '',
          deliverytype: '',
          '20vendorrebate': this.rb20Amt,
          '20vendorrebatetype': this.chargeCodes[0]['Amount Type']?.['label'] || '',
          '40vendorrebate': this.rb40Amt,
          '40vendorrebatetype': this.chargeCodes[0]['Rebate Type']?.['label'] || '',
          defaultrate: 'Yes',
          chargedetails: this.chargeCodes.map((chargeCode) => ({
            chargecode: chargeCode['Charge Code']['Charge Code'],
            amounttype: chargeCode['Amount Type']?.['label'] || '',
            '20amount': chargeCode['20Amount'],
            '40amount': chargeCode['40Amount'],
            rebatetype: chargeCode['Rebate Type']?.['label'] || '',
            '20rebatevalue': chargeCode['20Rebate'],
            '40rebatevalue': chargeCode['40Rebate'],
            defaultcharges: chargeCode['Default Charges'] === '1' ? '1' : '0',
          })),
        };
        // for container rate
      } else if (this.showContainerRate) {

        requestBody = {
          // all the data
          action: action,
          dateupdate: new Date().formatString('yyyy-MM-dd'),
          base: this.baseInputValue.trim(),
          datestart: '',
          billingcustomer: this.selectedBillingCustomer ? this.selectedBillingCustomer['Customer Code'] : '',
          customer: this.selectedCustomer ? this.selectedCustomer['Customer Code'] : '',
          destinationcode: this.selectedDestinationCode['Destination Code'],
          haulier: this.selectedHaulier['Haulier Code'],
          containertype: this.selectedContainerType['Cont Type'],
          handlingtype: this.selectedHandlingType['Handling Type'],
          deliverytype: this.selectedDeliveryType['Delivery Type'],
          defaultrate: 'No',
          '20vendorrebate': this.rb20Amt,
          '20vendorrebatetype': this.chargeCodes[0]['Amount Type']?.['label'] || '',
          '40vendorrebate': this.rb40Amt,
          '40vendorrebatetype': this.chargeCodes[0]['Rebate Type']?.['label'] || '',
          chargedetails: this.chargeCodes
            // .filter((chargeCode) => chargeCode['Default Charges'] !== '1')
            .map((chargeCode) => ({
              chargecode: chargeCode['Charge Code']['Charge Code'],
              amounttype: chargeCode['Amount Type']?.['label'] || '',
              '20amount': chargeCode['20Amount'],
              '40amount': chargeCode['40Amount'],
              rebatetype: chargeCode['Rebate Type']?.['label'] || '',
              '20rebatevalue': chargeCode['20Rebate'],
              '40rebatevalue': chargeCode['40Rebate'],
              defaultcharges: chargeCode['Default Charges'] === '1' ? '1' : '0',
            })),
        };
      }

      return requestBody;
    },
    //triggered when the user clicks on the default checkbox
    handleDefaultChargesChange: function (chargeCode, isChecked) {
      if (isChecked) {
        // reset to stored default values (ensure original values exist)
        if (chargeCode._defaultValues) {
        // if exists, saved default value of 20amount from _defualtvalues assign bacck to charge code 20 amount.
          chargeCode['20Amount'] = chargeCode._defaultValues['20Amount'];
          chargeCode['40Amount'] = chargeCode._defaultValues['40Amount'];
          chargeCode['20Rebate'] = chargeCode._defaultValues['20Rebate'];
          chargeCode['40Rebate'] = chargeCode._defaultValues['40Rebate'];
          chargeCode['Amount Type'] = chargeCode._defaultValues['Amount Type'];
          chargeCode['Rebate Type'] = chargeCode._defaultValues['Rebate Type'];
        }
        chargeCode['Default Charges'] = '1';
      } else {
        // let user to edit when unchecked, but keep values intact
        chargeCode['Default Charges'] = '0';
      }
    },

    //triggered when the user clicks on the required error message
    popupEntryRequiredClicked: function (item) {
      this.$nextTick(() => {
        this.$refs[item].setFocus();
      });
    },

    populateTextTrim: function (text) {
      // To populate text with trim
      return text ? String(text).trim() : '';
    },
    //Searches for a matching object in a list
    populateObject: function (data, key, compare) {
      // To populate object into dropdown or input query
      try {
        return data.find((d) => (d[key]?.trim?.() ?? d[key]) == (compare?.trim?.() ?? compare));
      } catch (error) {
        return null;
      }
    },
  },
  async mounted() {
    this.$bus.$on('pageSASControlAccess', (x) => {
      if (x.page == 'Container Rate') {    
        x.data.forEach(k => {
          //key in menu same as control value from api
          const selectedMenu = this.menu.find(m => m['key'] == k['Control']);
          if (selectedMenu) {
            selectedMenu[k['Properties'].toLowerCase()] = (k['PropertiesValue'] == 'True');
          }
        });
      }
    });
    // let sasControl = [];
    // sasControl = await this.$apiCallV2(`/SASControl/GetSASControlAccess?system=MASTER&page=Container%20Rate`);
    // await Promise.allSettled(mountedPromises).then((_promiseOutcomes) => {
    //   this.menu = this.menu.map((menu) => ({
    //           ...menu,
    //           enabled: true,
    //         }));

    //   sasControl.forEach((s) => {
    //     const menu = this.menu.find((m) => m['key'] == s['Control']);
    //     if(menu) {
    //       menu[s['Properties'].toLowerCase()] = s['PropertiesValue'] !== 'False';
    //       menu['message'] = 'Access Denied';
    //     }
    //   });
    // });

    await this.fetchCurrentBase();
    
    const mountedPromises = [];
    let promisesFulfilled = 0;

   

    mountedPromises.push(
      this.getContainerRateListMaster().then(() => {
        this.$topLoading(++promisesFulfilled / mountedPromises.length);
      }),
    );
    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'CHARGESCODE' }).then((result) => {
        this.chargeCodeListMaster = result.map((item) => ({
          ...item,
          // combinedChargeCode: `${item['Charge Code']} - ${item['Description']}`,
          combinedChargeCode: `${item['Charge Code']}`,
        }));
        this.$topLoading(++promisesFulfilled / mountedPromises.length);
      }),
    );

    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'CUSTOMER' }).then((result) => {
        this.billingCustomerListMaster = result.map((item) => ({
          ...item,
          combinedBillingCustomer: `${item['Customer Code']}`,
        }));
        this.$topLoading(++promisesFulfilled / mountedPromises.length);
      }),
    );

    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'SHIPPERCONSIGNEE' }).then((result) => {
        this.customerListMaster = result.map((item) => ({
          ...item,
          combinedCustomer: `${item['Customer Code']}`,
        }));
        this.$topLoading(++promisesFulfilled / mountedPromises.length);
      }),
    );

    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'HAULIERCHARGES_DESTINATION' }).then((result) => {
        this.destinationCodeListMaster = result.map((item) => ({
          ...item,
          combinedDestinationCode: `${item['Destination Code']}`,
        }));
        this.$topLoading(++promisesFulfilled / mountedPromises.length);
      }),
    );

    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'HAULIER' }).then((result) => {
        this.haulierListMaster = result.map((item) => ({
          ...item,
          combinedHaulier: `${item['Haulier Code']} - ${item['Description']}`,
        }));
        this.$topLoading(++promisesFulfilled / mountedPromises.length);
      }),
    );

    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'CONTHANDLINGTYPE' }).then((result) => {
        this.handlingTypeListMaster = result.map((item) => ({
          ...item,
          combinedHandlingType: `${item['Handling Type']} - ${item['Description']}`,
        }));
        this.$topLoading(++promisesFulfilled / mountedPromises.length);
      }),
    );

    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'CONTTYPE' }).then((result) => {
        this.containerTypeListMaster = result.map((item) => ({
          ...item,
          combinedContainerType: `${item['Cont Type']} - ${item['Description']}`,
        }));
        this.$topLoading(++promisesFulfilled / mountedPromises.length);
      }),
    );

    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'CONTDELIVERYTYPE' }).then((result) => {
        this.deliveryTypeListMaster = result.map((item) => ({
          ...item,
          combinedDeliveryType: `${item['Delivery Type']} - ${item['Description']}`,
        }));
        this.$topLoading(++promisesFulfilled / mountedPromises.length);
      }),
    );

    Promise.allSettled(mountedPromises).then((_promiseOutcomes) => {
      this.menu = this.menu.map((menu) => ({
        ...menu,
        enabled: true,
      }));
    });
  },
  watch: {
    // watch for changes in the selected customer
    showAllDestinationCodes: 'updateFilteredDestinationCodes',
    selectedCustomer: 'updateFilteredDestinationCodes',
    destinationCodeListMaster: 'updateFilteredDestinationCodes',
  },
};
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';
.container-rate-main {
  font-size: 12px;
  width: 100%;
  height: 100%;
  padding: 10px 45px;
  display: flex;

  > .table-box-container {
    width: 100%;
    margin-left: 5px;
    padding: 5px;
    background-color: white;
    border-radius: 5px;
    display: flex;
    overflow: hidden;
  }
.tab-component {
      height: calc(100% - 60px);

      .default-code {
        display: flex;
        flex-direction: column;
      }

      container-rate-code {
        display:flex;
        flex-direction: column;
      }
}
  .details-row {
    display: flex;
    flex-direction: row;
  }

  .tariff-label {
    width: 25%;
    margin-right: 5px;
  }
  .rebate-label {
    width: 25%;
    margin-right: 20px;
  }

  .tariff-rate-input {
    display: flex;
    flex-direction: row;
    gap: 10px;
    margin-top: 15px;
  }

  .rebate-input {
    display: flex;
    flex-direction: row;
    gap: 10px;
    margin-top: 15px;
  }

  .charge-code-component {
    max-height: 275px;
    overflow-y: auto;
  }
  .charge-code-table {
    display: grid;
    grid-template-columns: 2.5% 15% 25% 25% 15% 7.5% 5%;
    gap: 10px;
    width: 100%;
  }

  .charge-code-header,
  .charge-code-row {
    display: contents;
    padding-bottom: 10px;
  }

  .charge-code-header {
    font-weight: bold;
  }

  .amount-input,
  .adjust-amount-input,
  .nett-input {
    display: flex;
    gap: 10px;
  }

  .actions-column {
    display: flex;
  }

  .total-block {
    border: 1px solid rgba(128, 128, 128, 0.5);
    padding: 5px 10px;
    align-content: space-evenly;
    min-width: 210px;
    padding-right: 5px;
    display: inline;
    text-align: right;
  }
}
</style>
